import { AnyAction } from "@reduxjs/toolkit";
import * as AT from "./actionTypes";
import { AuthenticationState } from "../../../../models/state";
import * as CHECKOUT_AT from "../../checkout/state/actionTypes";
import { ONBOARDING_VERIFY_UPDATED_NAME } from "../../onboardingB2B/state/actionTypes";
import { PREPAID_REGISTRATION_VERIFY_UPDATED_NAME } from "../../prepaid/state/actionTypes";

import { fulfilled, rejected } from "../utils";

export const initialState = (): AuthenticationState => ({
    isAuthenticated: false,
    bankId: {
        url: "",
        redirectUrl: "",
        customer: undefined,
        verified: false,
        available: false,
        performed: false,
        mandatory: false,
        error: false,
    },
    requestor: "",
});

const reducer = (state = initialState(), action: AnyAction) => {
    switch (action.type) {
        case AT.AUTH_LOGOUT_SUCCEEDED:
        case AT.AUTH_IS_AUTHENTICATED_SUCCEEDED:
            return {
                ...initialState(),
                ...action.data,
                bankId: state.bankId,
                requestor: state.requestor,
            };
        case fulfilled(AT.AUTH_BANK_ID_AUTHORIZE):
            return {
                ...state,
                bankId: {
                    ...state.bankId,
                    url: action.payload.url,
                    code: null,
                    verified: false,
                },
            };
        case fulfilled(AT.AUTH_BANK_ID_AVAILABLE):
            return {
                ...state,
                bankId: {
                    ...state.bankId,
                    available: action.payload.available,
                    mandatory: action.payload.mandatory,
                    verified: action.payload.verified,
                },
            };
        case rejected(AT.AUTH_BANK_ID_AVAILABLE):
            return {
                ...state,
                bankId: {
                    ...state.bankId,
                    available: null,
                },
            };
        case fulfilled(AT.AUTH_BANK_ID_GRANT):
            return {
                ...state,
                bankId: {
                    ...state.bankId,
                    verified: !action.payload.isDsfMismatch,
                },
            };
        case rejected(AT.AUTH_BANK_ID_GRANT):
            return {
                ...state,
                bankId: {
                    ...state.bankId,
                    verified: false,
                    error: true,
                },
            };
        case AT.AUTH_BANK_ID_RESET:
        case fulfilled(CHECKOUT_AT.CONSENT_TO_B2B_BANKID_RESET):
        case fulfilled(CHECKOUT_AT.CHECKOUT_CHECK_EXISTING_PHONE_NUMBER):
        case fulfilled(CHECKOUT_AT.CHECKOUT_SET_MAIN_SUBSCRIPTION):
        case fulfilled(CHECKOUT_AT.CHECKOUT_RESET_ORDER):
            return {
                ...state,
                bankId: {
                    ...(state.bankId || {}),
                    url: state.bankId?.url,
                    code: null,
                    performed: false,
                    verified: false,
                    error: false,
                },
            };
        case fulfilled(PREPAID_REGISTRATION_VERIFY_UPDATED_NAME):
        case fulfilled(ONBOARDING_VERIFY_UPDATED_NAME):
            return {
                ...state,
                bankId: {
                    ...(state.bankId || {}),
                    verified: !!action.payload.bankId?.verified,
                    performed: !!action.payload.bankId?.performed,
                    customer: {
                        firstName: action.payload.bankId?.customer?.firstName,
                        lastName: action.payload.bankId?.customer?.lastName,
                    },
                },
            };
        default:
            return state;
    }
};

export default reducer;
